/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("PrefixedConsoleLogProvider", ["LogProviderBase"], function (context, cls) {
  /**
   * @class PrefixedConsoleLogProvider
   * @memberOf classes
   * @extends classes.LogProviderBase
   */
  class PrefixedConsoleLogProvider extends cls.LogProviderBase /** @lends classes.PrefixedConsoleLogProvider.prototype */ {
    constructor(prefix, prefixStyle) {
      super(prefix, prefixStyle);
      const _prefix = (prefixStyle ? "%c" : "") + prefix;
      this._logger = {
        debug: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.debug(...args);
        },
        log: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.log(...args);
        },
        info: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.info(...args);
        },
        warn: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.warn(...args);
        },
        error: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.error(...args);
        },
        record: function () {
          const args = Array.prototype.slice.call(arguments);
          const logStr = args.join(" ");
          const t = new Date().getTime();

          const entry = {
            provider: prefix.replaceAll(/\s/g, ""),
            t: t,
            log: logStr
          };
          context.LogService.record(entry);
        }
      };
    }
    getLogger() {
      return this._logger;
    }
  }
  cls.PrefixedConsoleLogProvider = PrefixedConsoleLogProvider;
});
